import api from './api/index.js';

var util = {
    checklimit: function (limits, goods_id, num) {

        console.log("limits", limits, goods_id);

        return new Promise((resolve, reject) => {
            if (limits != "" && limits != null) {
                api.post(
                    api.base,
                    "/wxapi/shopcar/list",
                    { token: localStorage.getItem("loginMobile") },
                    (r) => {
                        if (r.data.status == 200) {
                            var list = r.data.data;
                            var y = true;
                            if (list.length == 0) {
                                console.log("sss", num, limits);
                                if (num > limits) {
                                    y = false;
                                }
                            } else {
                                for (var i = 0; i < list.length; i++) {
                                    console.log("对比", list[i].num, limits);
                                    if (
                                        list[i].goods_id == goods_id &&
                                        list[i].num >= (limits)
                                    ) {
                                        y = false;
                                    }
                                }
                                console.log("y", y);
                            }

                            resolve(y);
                        }
                    }
                );
            } else {
                resolve(true);
            }

        });
    },
    checklimitadd: function (limits, goods_id, num) {

        console.log("limits", limits, goods_id);

        return new Promise((resolve, reject) => {
            if (limits != "" && limits != null) {
                api.post(
                    api.base,
                    "/wxapi/shopcar/list",
                    { token: localStorage.getItem("loginMobile") },
                    (r) => {
                        if (r.data.status == 200) {
                            var list = r.data.data;
                            var y = true;

                            if (list.length == 0) {
                                console.log("sss1111111", num, limits);
                                if (num > limits) {
                                    y = false;
                                }
                            } else {
                                var obj = "";
                                for (var i = 0; i < list.length; i++) {
                                    console.log("对比1111", list[i].num + num, limits);
                                    if (list[i].goods_id == goods_id) {
                                        obj = list[i];
                                        break;
                                    }
                                }
                                console.log("obj",obj);
                                if (obj == "") {
                                    if (num > limits) {
                                        y = false;
                                    }
                                } else {
                                    if (
                                        (obj.num + num) > (limits)
                                    ) {
                                        y = false;
                                    }
                                }
                                console.log("y", y);
                            }

                            resolve(y);
                        }
                    }
                );
            } else {
                resolve(true);
            }

        });
    },
    buycount() {
        return new Promise((resolve, reject) => {
            api.post(
                api.base,
                "/wxapi/shopcar/list",
                { token: localStorage.getItem("loginMobile") },
                (r) => {
                    if (r.data.status == 200) {

                        var list = r.data.data;
                        var sum = 0;
                        for (let i = 0; i < list.length; i++) {
                            sum += list[i].num;
                        }

                        resolve(sum);



                    }
                }
            );


        });


    }



}



export default util